/** The Python `Final`s the browser mirrors; a Vitest test compares them to `constants.json`. */

export const PAGE_ROWS_MAX = 200;
export const STREAMS_PER_IDENTITY = 2;
export const SUBSCRIPTIONS_PER_STREAM = 8;
export const TRANSIENT_BUFFER_EVENTS = 1000;
export const CHART_POINTS_MAX = 10_000;
/** The declared scale of a board probability (`ssi.api.views.PROBABILITY_SCALE`). */
export const PROBABILITY_SCALE = 4;
export const CSRF_HEADER = "X-SSI-CSRF";
export const CLAIM_HEADERS: readonly string[] = [
  "x-actor",
  "x-approval",
  "x-grant",
  "x-identity",
  "x-on-behalf-of",
  "x-role",
  "x-ssi-actor",
  "x-ssi-approval",
  "x-ssi-approver",
  "x-ssi-grant",
  "x-ssi-identity",
  "x-ssi-role",
];

export const COMMANDS_PATH = "/api/v1/commands";
export const SESSIONS_PATH = "/api/v1/me/sessions";
export const STREAM_PATH = "/api/v1/stream";
export const HEALTH_PATH = "/api/v1/health/projections";
export const SESSION_PATH = "/auth/session";
export const LOGOUT_PATH = "/auth/logout";
/** The prefix of `ssi.api.views.VIEWS_PATH` (`/api/v1/views/{name}`). */
export const VIEWS_PATH = "/api/v1/views";
/** The view projections `ssi.api.views.VIEW_SCHEMAS` declares. */
export const VIEWS: readonly string[] = [
  "accounts",
  "board",
  "detail",
  "scanner",
  "scanner_funnel",
  "today",
];
export const RUM_PATH = "/api/v1/rum";
